"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                CountTile_Count: "Count",
                Tile_Click: "Click tile",
                Tile_OpenRefresh: "Open refresh dialog",
                Tile_RefreshNow: "Begin update now",
                Tile_TimeSinceRefreshPrefix: "Last updated: {0} ago",
                Tile_TimeUntilRefreshPrefix: "Next update:",
            }
        });
        /**
         * Extends the Tile control and adds data cache query capabilities.
         * The count tile architecture expects the descriptor provide a definition for two functions:
         * 1. getData - getter to fetch the current data cache values
         * 2. ForceRefresh - getter to force a cache update and then fetch the current data cache values
         * @param data Context provided when created the control.
         */
        var CountTile = /** @class */ (function (_super) {
            __extends(CountTile, _super);
            function CountTile(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Start the async process to force a data cache update and process the returned data.
                 */
                _this.refreshNow = function () {
                    $dyn.async(function () {
                        $dyn.callFunction(_this.ForceRefresh, _this, [], forceRefreshCallback);
                        _this.isRefreshDialogOpen(false);
                    }, undefined, "Tiles: refreshNow calling ForceRefresh");
                    // function forceRefreshCallback(controlData: string) {
                    var forceRefreshCallback = function (controlData) {
                        _this.processCountTileData(controlData);
                    };
                };
                _this.dataCacheCallback = function (result) {
                    _this.processCountTileData(result);
                    _this.setNextDataRequest();
                };
                _this.processCountTileData = function (dataStructure) {
                    var parsedStructure;
                    if (dataStructure && !$.isPlainObject(dataStructure)) {
                        parsedStructure = JSON.parse(dataStructure);
                    }
                    else {
                        parsedStructure = dataStructure;
                    }
                    if (parsedStructure) {
                        _this.Count(parsedStructure.strTileData);
                        _this.TileTitle($dyn.format("{0}\n{1}: {2}", $dyn.value(_this.Label), $dyn.label("CountTile_Count"), $dyn.value(_this.Count)));
                        _this.cacheLastUpdateMomentUTC = moment.utc(parsedStructure.strLastUpdate, "M/D/YYYY HH:mm:ss", true);
                        _this.plannedRefreshFrequencyMilliseconds = parsedStructure.strRefreshFrequencySeconds !== "0"
                            ? parseInt(parsedStructure.strRefreshFrequencySeconds, 10) * 1000
                            : $dyn.ui.TileStandardRetryFrequencyMilliseconds;
                        _this.isManualRefreshEnabled(parsedStructure.isManualRefreshEnabled);
                    }
                    else {
                        $dyn.logError("Unexpected data structure provided to processCountTileData");
                        _this.cacheLastUpdateMomentUTC = moment.utc();
                        _this.plannedRefreshFrequencyMilliseconds = $dyn.ui.TileStandardRetryFrequencyMilliseconds;
                        _this.isManualRefreshEnabled(false);
                    }
                    _this.lastDataReceivedMomentUTC = moment.utc(); // When we last received data from the cache
                };
                /**
                 * To be called on a timeout, confirms if the tile data should be refreshed and then calls for the data.
                 */
                _this.scheduledDataRequest = function () {
                    if (_this.Root) {
                        // The tile could be on a form or on a form part.
                        if ($dyn.value(_this.Root.isRootFormActive)) {
                            $dyn.log("Tiles: Count Tile is calling getData after timeout");
                            _this.requestTileData();
                        }
                        else {
                            $.when($dyn.deferred.onTrue(function () {
                                return $dyn.value(_this.Root.isRootFormActive);
                            }).done(function () {
                                $dyn.log("Tiles: Count Tile is calling getData after root form is reactivated");
                                _this.scheduledFirstRetry = false;
                                _this.requestTileData();
                            }));
                        }
                    }
                    else {
                        _this.nextUpdateTimerId = undefined;
                        $dyn.logWarning("Tiles: Did not refresh count tile data for %s, self.Root was not found.", _this.Name);
                    }
                };
                /**
                 * Set a timeout to request count tile data.
                 * @description In case the previous request result in a cache miss, update the refresh frequency.
                 */
                _this.setNextDataRequest = function () {
                    _this.nextUpdateTimerId = window.setTimeout(_this.scheduledDataRequest, _this.currentRefreshFrequencyMilliseconds);
                    // If no count was provided, plan to retry on a decaying frequency.
                    if ($dyn.value(_this.Count) === "--" && _this.currentRefreshFrequencyMilliseconds < _this.plannedRefreshFrequencyMilliseconds / 2) {
                        _this.currentRefreshFrequencyMilliseconds *= 2;
                    }
                    else {
                        _this.currentRefreshFrequencyMilliseconds = _this.plannedRefreshFrequencyMilliseconds;
                    }
                };
                _this.tileRefresh = function (newVal) {
                    if (newVal) {
                        $dyn.log("Tiles: tileRefresh");
                        _this.requestTileData();
                    }
                };
                _this.isRefreshDialogOpen = $dyn.observable(false);
                _this.timeSinceTileRefreshText = $dyn.observable("");
                _this.timeUntilTileRefreshText = $dyn.observable("");
                _this.refreshFlyoutOptions = {
                    at: "right center",
                    flyout: $(_this.element).find(".tile-refreshFlyout"),
                    my: "left top",
                    show: _this.isRefreshDialogOpen
                };
                _this.refreshNowLabel = $dyn.label("Tile_RefreshNow");
                $dyn.observe(_this.isRefreshDialogOpen, function (isOpen) {
                    if (isOpen) {
                        var currentMomentUtc = moment.utc();
                        var cacheLastUpdatedMomentUtc = _this.cacheLastUpdateMomentUTC;
                        var dataReceivedMomentUtc = _this.lastDataReceivedMomentUTC;
                        var scheduledRefreshMilliseconds = _this.currentRefreshFrequencyMilliseconds;
                        // with respect to when the cache last updated
                        _this.updateTimeSinceRefresh(currentMomentUtc, cacheLastUpdatedMomentUtc);
                        // with respect to when the webclient will next ask for the current cache value
                        _this.updateTimeUntilRefresh(currentMomentUtc, dataReceivedMomentUtc, scheduledRefreshMilliseconds);
                    }
                });
                _this.hasCountAndImage = $dyn.computed(function () {
                    var buttonDisplay = _this.buttonDisplay;
                    var imageName = $dyn.value(_this.ImageName);
                    var imageType = $dyn.value(_this.ImageType);
                    if (buttonDisplay !== $dyn.ui.ButtonDisplay.textOnly
                        && (buttonDisplay !== $dyn.ui.ButtonDisplay.backgroundImage || (buttonDisplay === $dyn.ui.ButtonDisplay.backgroundImage && imageType === "Symbol"))
                        && imageName) {
                        return true;
                    }
                });
                _this.initTile();
                return _this;
            }
            /**
             * The keydown event handler
             * @param event The keydown event
             */
            CountTile.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            CountTile.prototype.requestTileData = function () {
                var _this = this;
                if (this.nextUpdateTimerId) {
                    window.clearTimeout(this.nextUpdateTimerId);
                    this.nextUpdateTimerId = undefined;
                }
                if (this.getData) {
                    $dyn.async(function () {
                        $dyn.callFunction(_this.getData, _this, [], _this.dataCacheCallback);
                    }, undefined, "Tiles: Count tile requestTileData calling getData");
                }
                else {
                    $dyn.logWarning("Tiles: Data cache disabled, unable to retrieve tile count.");
                }
            };
            CountTile.prototype.initTile = function () {
                this.cacheLastUpdateMomentUTC = moment.utc();
                this.lastDataReceivedMomentUTC = moment.utc();
                this.currentRefreshFrequencyMilliseconds = $dyn.ui.TileFastestRetryFrequencyMilliseconds;
                this.isManualRefreshEnabled = $dyn.observable(false);
                this.TileTitle = $dyn.observable("");
                this.requestTileData();
                if ($dyn.value(this.Refreshing) != null) {
                    // If a refresh observable was specified, observe that and trigger an update when true
                    $dyn.observe(this.Refreshing, this.tileRefresh);
                }
                else if (this.Root && this.Root.Refreshing) {
                    // Otherwise if a root form is available, observe the form's Refreshing property and trigger an update when true
                    $dyn.observe(this.Root.Refreshing, this.tileRefresh);
                }
            };
            /**
             * Setter for the timeSinceTileRefreshText observable. In case of a cache miss, the time is set to "--".
             * @param currentMomentUtc moment.js object for the current time, in UTC.
             * @param lastUpdatedMomentUtc moment.js object for when the data was last updated, in UTC.
             */
            CountTile.prototype.updateTimeSinceRefresh = function (currentMomentUtc, lastUpdatedMomentUtc) {
                var label = $dyn.label("Tile_TimeSinceRefreshPrefix");
                var value = lastUpdatedMomentUtc.isSame("1900-01-01", "day")
                    ? "--"
                    : $dyn.format(label, $dyn.util.elapsedTimeDisplayText(currentMomentUtc, lastUpdatedMomentUtc));
                this.timeSinceTileRefreshText(value);
            };
            /**
             * Setter for the observable to display the duration until the next automatic count data refresh.
             * @param currentMomentUtc moment.js object for the current time, in UTC.
             * @param lastUpdatedMomentUtc moment.js object for when the data was last updated, in UTC.
             * @param scheduledRefreshMilliseconds current data refresh frequency for the tile.
             */
            CountTile.prototype.updateTimeUntilRefresh = function (currentMomentUtc, lastUpdatedMomentUtc, scheduledRefreshMilliseconds) {
                var nextUpdateMomentUtc = lastUpdatedMomentUtc.clone().add(scheduledRefreshMilliseconds, "ms");
                var prefix = $dyn.label("Tile_TimeUntilRefreshPrefix");
                var value = $dyn.util.elapsedTimeDisplayText(currentMomentUtc, nextUpdateMomentUtc);
                this.timeUntilTileRefreshText(prefix + " " + value);
            };
            return CountTile;
        }($dyn.controls.Tile));
        controls.CountTile = CountTile;
        $dyn.ui.addObservablePropertiesToPrototype(CountTile.prototype, {
            Count: "--",
            Refreshing: null
        });
        // tslint:disable:object-literal-sort-keys
        var countTileShortcuts = {
            OpenRefreshDialog: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    this.isRefreshDialogOpen(true);
                    return true;
                },
                Description: $dyn.label("Tile_OpenRefresh"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            }
        };
        // tslint:enable:object-literal-sort-keys
        CountTile.prototype.Shortcuts = $dyn.extendPrototype(CountTile.prototype.Shortcuts, countTileShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CountTile.js.map
